module.exports = "/365FarmNet/dist/fruitTable.f9375e9f41e7d1b681a8f9f0b109c717.html";